module.exports = __webpack_public_path__ + "img/11-crown-black-diamond.3bd7073d.png";